import { Button, Stack, styled } from "@mui/material";

const Container = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.secondary10.main,
  borderRadius: "8px",
  width: "fit-content",
  flexDirection: "row",
  justifyContent: "center",
}));

const CustomToggleButton = ({
  buttonContent,
}: {
  buttonContent: Array<{
    title: string;
    selected: boolean;
    onClick: () => void;
  }>;
}) => {
  return (
    <Container>
      {buttonContent.map((button, index) => (
        <Button
          key={index}
          color="secondary"
          sx={(theme) => ({
            backgroundColor: button.selected ? theme.palette.secondary50.main : theme.palette.secondary10.main,
            boxShadow: "none",
            "&:hover": {
              backgroundColor: theme.palette.secondary20.main,
              boxShadow: "none",
            },
            color: button.selected ? theme.palette.text10.main : theme.palette.secondary60.main,
          })}
          onClick={button.onClick}
          size="xSmall"
        >
          {button.title}
        </Button>
      ))}
    </Container>
  );
};

export default CustomToggleButton;
